import { render, staticRenderFns } from "./PointTitles.vue?vue&type=template&id=659d3fbc"
import script from "./PointTitles.vue?vue&type=script&lang=js"
export * from "./PointTitles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports